module.exports = __webpack_public_path__ + "media/bootstrap-icons/layer-backward-230dc34d.svg";